export default function formatCount(count, subject) {
  const formatted = `${count || 'No'} ${subject}`;
  if (count === 1) {
    return formatted;
  }
  return `${formatted}s`;
}
